import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/db-insights/')({
  beforeLoad: () => {
    throw redirect({ to: '/db-insights/tables' });
  }
});
